import { Type } from 'class-transformer';
import { EnaioDocumentResult } from 'src/modules/enaio-documents/models/enaio-document-result.model';
import { EnaioWorkItem } from 'src/modules/enaio/shared/EnaioWorkItem';

export class EnaioWorkItemDto {

    @Type(() => EnaioWorkItem)
    workItem: EnaioWorkItem;
    @Type(() => EnaioDocumentResult)
    documents: EnaioDocumentResult[];
}
